module.exports = __webpack_public_path__ + "img/img-3-11mobile.861ecd60.webp";